import React from 'react';
import PropTypes from 'prop-types';

import { Card } from 'components/legacy/Card';
import { H2, Paragraph } from 'components/core/Typography';
import { SearchBox } from 'components/search/SearchBox';
import MapPin from 'components/svg/MapPin';

import './PLPBottom.scss';

export function PLPBottom({ storageType, handleSearch }) {
	return (
		<div className="plp-bottom-container">
			<Card className="plp-bottom">
				<H2
					size="large"
					family="rounded"
					weight="bold"
				>
					Find {storageType} Storage Near You
				</H2>
				<Paragraph
					size="tall"
					color="gray"
				>
					Make a free reservation in minutes!
				</Paragraph>
				<SearchBox
					defaultButton={false}
					icon={<MapPin />}
					id="bottom-search"
					inputLabel="Enter address, city, or zip code"
					onSearch={handleSearch}
					useBrowserLocation
				/>
			</Card>
		</div>
	);
}

PLPBottom.propTypes = {
	storageType: PropTypes.string,
	location: PropTypes.string,
	handleSearch: PropTypes.func,
};
